import axios from 'axios';
import '../config.js';

const base = (path) => `${global.config.url}/wallet${path}`;

const tokenConfig = (token) => ({
  params: { token },
});

const walletPortalApi = {
  createSession: async (code) => (await axios.post(base('/portal/session'), { code })).data,
  getAvailability: async (locationId, token) => (await axios.get(base(`/portal/locations/${locationId}/availability`), tokenConfig(token))).data,
  getAccessPoints: async (locationId, token) => (await axios.get(base(`/portal/locations/${locationId}/access-points`), tokenConfig(token))).data,
  getPasses: async (locationId, token) => (await axios.get(base(`/portal/locations/${locationId}/passes`), tokenConfig(token))).data,
  createPass: async (locationId, token, payload) => (await axios.post(base(`/portal/locations/${locationId}/passes`), payload, tokenConfig(token))).data,
  revokePass: async (locationId, passId, token) => axios.delete(base(`/portal/locations/${locationId}/passes/${passId}`), tokenConfig(token)),
};

export default walletPortalApi;